import { render, staticRenderFns } from "./FilesystemUsersLeave.vue?vue&type=template&id=5b76be29&"
import script from "./FilesystemUsersLeave.vue?vue&type=script&lang=ts&"
export * from "./FilesystemUsersLeave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports